var cardBalance = cardBalance || {};

cardBalance.query = (function () {
    function init() {
        var queryForm = document.querySelector('#cardBalanceQuery');
        var queryNumber = queryForm.querySelector('#number');
        var queryResult = document.querySelector('#cardBalanceResult');
        queryNumber.addEventListener('keydown', function (e) {
            var current = this.value.replace(/\s/g, '');
            if (current.length >= 16 && e.keyCode !== 46 && e.keyCode !== 8) {
                e.preventDefault();
            }
        });
        queryNumber.addEventListener('keyup', function (e) {
            var current = this.value.replace(/\D/g, '');
            var replacement = '';
            for(var i=0; i < current.length; i++) {
                if(i%4 === 0 && i > 0) {
                    replacement = replacement.concat(' ');
                }
                replacement = replacement.concat(current[i]);
            }
            this.value = replacement;
        });
        queryForm.addEventListener('submit', function (event) {
            event.preventDefault();
            var xhr = new XMLHttpRequest();
            xhr.open('GET', queryForm.getAttribute('action') + '?number=' + queryNumber.value);
            xhr.onload = function () {
                var data = JSON.parse(xhr.responseText);
                if (xhr.status === 200) {
                    queryResult.querySelector('.formattedCardNumber').textContent = data.formattedCardNumber;
                    queryResult.querySelector('.amount').textContent = data.formattedAmount;
                    queryResult.querySelector('.currency').textContent = data.currency;
                    queryForm.parentNode.removeChild(queryForm);
                    queryResult.style.display = 'block';
                } else {
                    queryNumber.insertAdjacentHTML('afterend', '<ul class="errors"><li>' + data.error + '</li></ul>');
                }
            };
            xhr.send();
        });
    }

    init();
});
